"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStateFromQuery = exports.parseErrorFromQuery = exports.parseCodeFromQuery = void 0;
var parseCodeFromQuery = function (query) {
    if (typeof query.code !== "string") {
        return { isValid: false, reason: null };
    }
    return {
        isValid: true,
        payload: query.code,
    };
};
exports.parseCodeFromQuery = parseCodeFromQuery;
var parseErrorFromQuery = function (query) {
    if (typeof query.error !== "string" ||
        typeof query.error_description !== "string") {
        return { isValid: false, reason: null };
    }
    return {
        isValid: true,
        payload: {
            error: query.error,
            error_description: query.error_description,
        },
    };
};
exports.parseErrorFromQuery = parseErrorFromQuery;
var parseStateFromQuery = function (query) {
    if (typeof query.state !== "string" || query.state === "") {
        return { isValid: false, reason: null };
    }
    var parsedState = JSON.parse(query.state);
    if (typeof parsedState.referrer !== "string" ||
        typeof parsedState.feedback !== "boolean") {
        return { isValid: false, reason: null };
    }
    return {
        isValid: true,
        payload: {
            referrer: parsedState.referrer,
            feedback: parsedState.feedback,
        },
    };
};
exports.parseStateFromQuery = parseStateFromQuery;
